/**
 * TechSpecPanel — Step 1 rich detail.
 *
 * Shows a structured tech spec sheet seeded from the order's product
 * description. "Generate" mocks an AI call; "Export PDF" is visual-only.
 */
import React, { useState } from 'react';
import { Sparkles, Download, FileText } from 'lucide-react';
import { useManifest } from '../ManifestContext';

const TechSpecPanel = ({ order }) => {
  const { updateOrderFields } = useManifest();
  const [generating, setGenerating] = useState(false);

  const sections = order.techSpec?.sections || [];

  const handleRegenerate = () => {
    setGenerating(true);
    // Demo: simulate a Claude call
    setTimeout(() => {
      updateOrderFields({
        techSpec: {
          ...order.techSpec,
          generated: true,
          lastUpdated: new Date().toISOString(),
        },
      });
      setGenerating(false);
    }, 900);
  };

  return (
    <div className="manifest-rich-panel manifest-techspec">
      <div className="manifest-rich-panel-head">
        <div className="manifest-rich-panel-title">
          <FileText size={16} /> Technical specification sheet
        </div>
        <div className="manifest-rich-panel-actions">
          <button className="manifest-btn-ghost" onClick={handleRegenerate} disabled={generating}>
            <Sparkles size={14} /> {generating ? 'Generating…' : 'Regenerate from contract'}
          </button>
          <button className="manifest-btn-ghost">
            <Download size={14} /> Export PDF
          </button>
        </div>
      </div>

      <div className="manifest-techspec-summary">
        <span className="manifest-techspec-eyebrow">Product</span>
        <p>{order.productSummary}</p>
        <div className="manifest-techspec-meta">
          <span><strong>Quantity:</strong> {order.quantity?.toLocaleString()}</span>
          <span><strong>Delivery:</strong> {order.deliveryRegion}</span>
          <span><strong>Last updated:</strong> {order.techSpec?.lastUpdated ? new Date(order.techSpec.lastUpdated).toLocaleDateString('en-CA') : '—'}</span>
        </div>
      </div>

      <div className="manifest-techspec-sections">
        {sections.map((s, i) => (
          <div key={i} className="manifest-techspec-section">
            <div className="manifest-techspec-section-heading">{s.heading}</div>
            <div className="manifest-techspec-section-body">{s.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechSpecPanel;
